import moment from 'moment';
import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Discount extends ApplicationRecord {
  static jsonapiType = 'discounts';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Promo Code',
        value: 'promoCode',
      },
      {
        text: 'Discount Rate',
        value: 'rate',
      },
      {
        text: 'Expires',
        value: 'validTo',
      },
      {
        text: 'Active',
        value: 'active',
        width: 80,
        align: 'center',
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return Discount.includes([]);
  }

  @Attr() name: string;
  @Attr() notes: string;
  @Attr() promoCode: string;
  @Attr() rate: string;
  @Attr() disabled: boolean;
  @Attr() validFrom: string;
  @Attr() validTo: string;
  @Attr() readonly active: boolean;
  @Attr() dropOffStart?: string;
  @Attr() dropOffEnd?: string;

  get toFormatted() {
    return moment(this.validTo).format('DD/MM/YYYY HH:mm');
  }

  get discountDetails() {
    return `${this.promoCode} - ${this.name}`;
  }
}
